// Values match the backend IncreasePopulation enum names. A const object rather
// than an enum because tsconfig enables erasableSyntaxOnly.
export const IncreasePopulation = {
  Ctc: "Ctc",
  Wage: "Wage",
} as const

export type IncreasePopulation =
  (typeof IncreasePopulation)[keyof typeof IncreasePopulation]

export const INCREASE_POPULATION_LABELS: Record<IncreasePopulation, string> = {
  [IncreasePopulation.Ctc]: "CTC",
  [IncreasePopulation.Wage]: "Wage",
}
